import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "el-textarea el-input--small limit-input"
};
const _hoisted_2 = ["placeholder"];
import { onMounted, ref, watch } from "vue";
import Cleave from "cleave.js";
export default {
  __name: 'CleaveNumberInput',
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    separator: {
      type: String,
      default: ","
    },
    decimalsCount: {
      type: Number,
      default: 2
    },
    digitCount: {
      type: Number,
      default: 5
    },
    max: Number,
    min: Number,
    thousandsSeparator: {
      type: String,
      default: " "
    },
    placeholder: String,
    setActive: {
      type: Function,
      default: () => {}
    }
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const inputRef = ref(null);
    let cleaveInstance;
    let isUserInput = false;

    // Convert a formatted string (e.g. "9.999,99") to a plain number (9999.99)
    function toRawNumber(val) {
      if (val === null || val === undefined) return null;
      if (typeof val === 'number') return val;
      let str = val.toString();
      if (props.thousandsSeparator) {
        str = str.split(props.thousandsSeparator).join('');
      }
      if (props.separator && props.separator !== '.') {
        str = str.replace(props.separator, '.');
      }
      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    }
    onMounted(() => {
      cleaveInstance = new Cleave(inputRef.value, {
        numeral: true,
        numeralDecimalMark: props.separator,
        numeralDecimalScale: props.decimalsCount,
        numeralThousandsGroupStyle: "thousand",
        numeralPositiveOnly: !(props.min !== undefined && props.min < 0),
        delimiter: props.thousandsSeparator,
        prefix: "",
        suffix: "",
        onValueChanged: onCleaveChange
      });

      // Set initial value if exists
      if (props.modelValue !== undefined && props.modelValue !== null) {
        const raw = toRawNumber(props.modelValue);
        if (raw !== null) {
          cleaveInstance.setRawValue(raw.toFixed(props.decimalsCount));
        }
      }
    });
    watch(() => props.modelValue, val => {
      if (cleaveInstance) {
        if (isUserInput) {
          isUserInput = false;
          return;
        }
        if (val === null || val === undefined) {
          cleaveInstance.setRawValue("");
        } else {
          const raw = toRawNumber(val);
          if (raw !== null && raw.toFixed(props.decimalsCount) !== cleaveInstance.getRawValue()) {
            cleaveInstance.setRawValue(raw.toFixed(props.decimalsCount));
          }
        }
      }
    });
    function onCleaveChange(e) {
      const raw = e.target.rawValue;
      if (!raw) {
        emit("update:modelValue", null);
        return;
      }
      // Allow typing just "-" without resetting (user is mid-input)
      if (raw === "-") {
        return;
      }
      const cleaned = cleaveInstance.getRawValue() ? cleaveInstance.getRawValue() : null;
      const [intPart = "", decPart = ""] = cleaned.split(".");
      const totalDigits = intPart.replace(/\D/g, "").length + decPart.slice(0, props.decimalsCount).length;
      let parsed = parseFloat(cleaned);
      if (totalDigits > props.digitCount || isNaN(parsed)) {
        cleaveInstance.setRawValue((props.modelValue ?? "").toString());
        return;
      }
      if (props.max !== undefined && parsed > props.max) {
        emit("update:modelValue", props.modelValue);
        cleaveInstance.setRawValue(props.modelValue.toString());
        return;
      }
      if (props.min !== undefined && parsed < props.min) {
        parsed = props.min;
        cleaveInstance.setRawValue(parsed.toString());
      }
      isUserInput = true;
      emit("update:modelValue", parsed);
      props.setActive();
    }
    function onInput(e) {
      const raw = cleaveInstance.getRawValue().replace(props.thousandsSeparator, "");
      const [intPart = "", decPart = ""] = raw.split(props.separator);
      const totalDigits = intPart.replace(/\D/g, "").length + decPart.slice(0, props.decimalsCount).length;

      // Prevent typing more than allowed digits
      if (totalDigits >= props.digitCount && e.data?.match(/\d/)) {
        e.preventDefault();
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("input", {
        ref_key: "inputRef",
        ref: inputRef,
        placeholder: __props.placeholder,
        onInput: onInput,
        class: "el-textarea__inner"
      }, null, 40, _hoisted_2)]);
    };
  }
};